import { defineComponent } from 'vue';
import { useBookingStore } from '../../store/bookingstore';

import { Booking } from "../../services/booking"
import { Payment } from "../../services/payment";

import header_menu from "../header/menu.vue"
import footer_item from "../base/common/footer.vue"
import hero from "../header/hero.vue"

import basket from "../base/common/basket.vue"
import basket_minimal from "../base/common/basket_minimal.vue"
import basket_header from "../base/common/header.vue"

import booking_notes from "../base/4_checkout/booking_notes.vue"
import trip_summary from "../base/4_checkout/summary.vue"
import { Web_Engine } from '../../services/web_engine';

import { response_booking } from "../../objects/v1_3/booking/search/response_booking";
import { response_booking_trip } from "../../objects/v1_3/booking/search/response_booking_trip";
import { response_booking_trip_passenger } from "../../objects/v1_3/booking/search/response_booking_trip_passenger";
import { currency } from "../../objects/v1_2/Currency/currency";
import { request_payment_initialise_internal } from "../../objects/v1_3/payment/initialise/request_payment_initialise_internal";
import { response_login_payment } from "../../objects/agent/identity/v1_3/response_login_payment";

let Book: Booking = new Booking();
let Pay: Payment = new Payment();
let web_engine: Web_Engine = new Web_Engine();
const isValid : boolean = false;

export default defineComponent({
    components: {
        booking_notes,
        footer_item,
        header_menu,
        basket,
        basket_minimal,
        basket_header,
        trip_summary,
        hero
    },
    data() {
        return {
            isValid,
            timedOut: false,
            user_currency: new currency as currency
            
        }
    },
    setup() {
        const bookingStore = useBookingStore();

        return {
            bookingStore
        }
    },
    methods: {
        isAgent_Login(): boolean {
            return this.$store.getters.get_Agent_Login?.valid_login == true;
        },
        async initView() {
            //if(this.$store.getters.get_Booking?.group_booking_id == undefined || this.$store.getters.get_Booking?.group_booking_id == 0 || this.$store.getters.get_Booking?.group_booking_id == null) {

                //see if we have a valid bookingid param (payment link)
                let booking_id : string = this.getPaymentBookingId() ?? "";
                let session_id : string = this.getPaymentSessionId() ?? "";
                let payment_app_id : string = import.meta.env.VITE_APP_ID;
                if (await this.has_Booking(booking_id, session_id)) {
                    // get the app_id for which the booking was made with (operator cert)
                    payment_app_id = this.getPaymentAffiliateId() ?? import.meta.env.VITE_APP_ID;
                    this.isValid = true;
                };
                this.bookingStore.payment_app_id = payment_app_id;
                //}
            return isValid;
        },
        Get_Payment_App_Id(): string {
            let payment_app_id : any = import.meta.env.VITE_PAYMENT_APP_ID; //default
            if (this.bookingStore.payment_app_id  != null && this.bookingStore.payment_app_id != '') {
                payment_app_id = this.bookingStore.payment_app_id; //set by paylink
            }
            return payment_app_id;
        },
        async has_Booking(group_booking_id: string, session_id: string) {
            let booking_details : response_booking = await Book.Get_Booking_Session(this.$store, group_booking_id, session_id).then((response) => {
                return response;
            });

            let payment_session : request_payment_initialise_internal = await Pay.Get_Payment_Session(this.$store, session_id, 'cybersource', this.Get_Payment_App_Id());
            payment_session.get_booking.trips = booking_details.trips;
            this.$store.commit('Payment_Session', { Payment_Session: payment_session });

            if (booking_details != null) {
                this.$store.commit("Set_Payment_Full_Payment", { Payment: payment_session.payment_initialise.full_payment });
                this.$store.commit("Set_Payment_Deposit", { Payment: payment_session.payment_initialise.deposit });
                this.$store.commit("Setup_Booking", { Booking_Details: payment_session.get_booking });

                var selected_payment_method : response_login_payment = new response_login_payment();
                selected_payment_method.method = 'CC';
                selected_payment_method.nett_gross = (payment_session.payment_initialise.nett_sale == true) ? "N" : "G";
                selected_payment_method.description = 'CreditCard';
                this.$store.commit("Set_Payment_Selected", { Selected_Payment: selected_payment_method});
       
                var firstTripCurrency : string = payment_session.payment_initialise.iso_currency_code ?? "GBP";; // booking_details.trips[0].iso_currency_code ?? "GBP";
                this.user_currency.currency_info = await web_engine.Get_Currency_By_Country_Code(firstTripCurrency);
                this.$store.commit('Initialise_Currency', { Currency_Details:  this.user_currency });
                return true
            };
            return false;
        },        
        getHeroImage(): string {
            return String(import.meta.env.VITE_DEFAULT_HERO_IMAGE);
        },
        home_Click() {
            this.$router.push('/');
        },
        getPaymentBookingId() {
            const urlParams = new URLSearchParams(window.location.search);
            return urlParams.get('bid');
        },
        getPaymentSessionId() {
            const urlParams = new URLSearchParams(window.location.search);
            return urlParams.get('sid');
        },
        getPaymentAffiliateId() {
            const urlParams = new URLSearchParams(window.location.search);
            return urlParams.get('aid');
        },
        async startTimeOut() {
            await new Promise(resolve => setTimeout(resolve, 60000));
            this.timedOut = true
        },
        getContactInfo(): string {
            if (import.meta.env.VITE_DEFAULT_CONTACT_LOGIN_TEXT != undefined) {
                return String(import.meta.env.VITE_DEFAULT_CONTACT_LOGIN_TEXT);
            }
            else {
                return String(import.meta.env.VITE_DEFAULT_CONTACT_TEXT);
            }
        }
    },
    mounted() {
        this.initView();
        this.startTimeOut();
    }
})